import(/* webpackMode: "eager" */ "/app/src/app/report/page.tsx");
